import { render, staticRenderFns } from "./PageIcon.vue?vue&type=template&id=4c9ba9f2&"
import script from "./PageIcon.vue?vue&type=script&lang=js&"
export * from "./PageIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c9ba9f2')) {
      api.createRecord('4c9ba9f2', component.options)
    } else {
      api.reload('4c9ba9f2', component.options)
    }
    module.hot.accept("./PageIcon.vue?vue&type=template&id=4c9ba9f2&", function () {
      api.rerender('4c9ba9f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/classPage/PageIcon.vue"
export default component.exports